import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const AdminLoginCard = () => {
  return (
    <div className="group bg-white rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 overflow-hidden border-2 border-transparent hover:border-purple-500">
      {/* Card header with gradient */}
      <div className="bg-gradient-to-br from-purple-500 to-purple-600 p-6 text-white">
        <div className="flex items-center justify-between mb-4">
          <div className="w-16 h-16 bg-white/20 backdrop-blur-sm rounded-xl flex items-center justify-center">
            <Icon name="Shield" size={32} color="#FFFFFF" />
          </div>
          <div className="bg-purple-400/30 backdrop-blur-sm px-3 py-1 rounded-full text-sm font-medium">
            Administrador
          </div>
        </div>
        <h2 className="text-2xl font-bold mb-2">Iniciar Sesión como Administrador</h2>
        <p className="text-purple-100">
          Accede al panel de administración y gestiona la plataforma BIZZNET
        </p>
      </div>

      {/* Card body */}
      <div className="p-6">
        <div className="space-y-4 mb-6">
          <div className="flex items-start gap-3">
            <div className="flex-shrink-0 mt-0.5">
              <div className="w-6 h-6 rounded-full bg-purple-100 flex items-center justify-center">
                <Icon name="Check" size={14} className="text-purple-600" />
              </div>
            </div>
            <div>
              <h3 className="font-semibold text-gray-900 mb-1">Gestión de Usuarios y Empresas</h3>
              <p className="text-sm text-gray-600">
                Administra cuentas, permisos y verificaciones de la plataforma
              </p>
            </div>
          </div>

          <div className="flex items-start gap-3">
            <div className="flex-shrink-0 mt-0.5">
              <div className="w-6 h-6 rounded-full bg-purple-100 flex items-center justify-center">
                <Icon name="Check" size={14} className="text-purple-600" />
              </div>
            </div>
            <div>
              <h3 className="font-semibold text-gray-900 mb-1">Supervisión de Pagos</h3>
              <p className="text-sm text-gray-600">
                Revisa y aprueba transacciones y membresías de usuarios
              </p>
            </div>
          </div>

          <div className="flex items-start gap-3">
            <div className="flex-shrink-0 mt-0.5">
              <div className="w-6 h-6 rounded-full bg-purple-100 flex items-center justify-center">
                <Icon name="Check" size={14} className="text-purple-600" />
              </div>
            </div>
            <div>
              <h3 className="font-semibold text-gray-900 mb-1">Análisis y Reportes</h3>
              <p className="text-sm text-gray-600">
                Visualiza estadísticas y métricas clave de la plataforma
              </p>
            </div>
          </div>

          <div className="flex items-start gap-3">
            <div className="flex-shrink-0 mt-0.5">
              <div className="w-6 h-6 rounded-full bg-purple-100 flex items-center justify-center">
                <Icon name="Check" size={14} className="text-purple-600" />
              </div>
            </div>
            <div>
              <h3 className="font-semibold text-gray-900 mb-1">Control Total del Sistema</h3>
              <p className="text-sm text-gray-600">
                Configura parámetros y mantén la seguridad de BIZZNET
              </p>
            </div>
          </div>
        </div>

        {/* Login button */}
        <Link
          to="/admin-login"
          className="w-full flex items-center justify-center gap-2 px-6 py-4 bg-purple-600 hover:bg-purple-700 text-white font-semibold rounded-xl transition-colors duration-200 shadow-md hover:shadow-lg group-hover:scale-105 transform"
        >
          <Icon name="LogIn" size={20} />
          <span>Iniciar Sesión como Administrador</span>
          <Icon name="ArrowRight" size={20} />
        </Link>

        {/* Additional info */}
        <div className="mt-4 text-center">
          <p className="text-xs text-gray-500">
            Al iniciar sesión, aceptas nuestros{' '}
            <Link to="/terms-and-conditions" className="text-purple-600 hover:underline">
              Términos y Condiciones
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default AdminLoginCard;